import MListGroup from './index.vue';

MListGroup.install = app => {
  app.component(MListGroup.name, MListGroup);
};

export default MListGroup;
